/*
 * @Author: Sergiy Samborskiy 
 * @Date: 2018-10-23 10:42:15 
 * @Last Modified by: Sergiy Samborskiy
 * @Last Modified time: 2019-11-27 12:36:25
 */

import _ from 'lodash';
import * as React from 'react';

import RaisedButton from 'material-ui/RaisedButton';
import AutoComplete from 'material-ui/AutoComplete';
import CreateUserPopup from './CreateUserPopup';

import api from 'services';
import * as cx from 'classnames';
import { SelectField, MenuItem } from 'material-ui';

class UserSelector extends React.Component {
    constructor(props) {
        super(props);
        
        this.state = {
            email: this.getUserMail(props),
            emails: [],
            isOpenAddUserPopup: false,
            emailWasSet: false,
        };

        this.changeEmail = this.changeEmail.bind(this);
        this.chooseEmail = this.chooseEmail.bind(this);
        this.openAddUserPopup = this.openAddUserPopup.bind(this);
        this.closeAddUserPopup = this.closeAddUserPopup.bind(this);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.letter.expectedBroker !== this.props.letter.expectedBroker) {
            nextProps.handleClientChange(null, null, nextProps.letter.expectedBroker ? nextProps.letter.expectedBroker.email : '');
        }

        const email = this.getUserMail(nextProps);
        if (email === this.state.email) {
            return;
        }

        if (this.state.emailWasSet) {
            return;
        }

        this.setState({
            email,
            emailWasSet: true,
        }, () => {
            const newUser = _.cloneDeep(this.props.user);
            newUser.email = this.state.email;
            this.props.onUserUpdate(newUser);            
        });
    }

    getUserMail(props) {
        if (props.letter.eh === 'api' && props.letter.owner) {
            return props.letter.owner.email;
        }
        if (props.letter.realUserEmail) {
            return props.letter.realUserEmail;
        }
        return props.user.email || (props.letter.sender && props.letter.sender[0].address);
    }

    loadUserInfo(emailLike) {
        return api.findUser(emailLike).then(response => response.data.data.map(item => ({
            email: item.email,
            item,
        }))).catch((err) => {
            console.error(err);
            return null;
        });
    }

    changeEmail(searchText) {
        this.setState({
            email: searchText,
        });
        this.loadUserInfo(searchText).then((emails) => {
            if (this.state.email !== searchText) {
                return;
            }

            this.setState({
                emails,
            });

            const newUser = _.cloneDeep(this.props.user);
            newUser.email = this.state.email;
            this.props.onUserUpdate(newUser);
        });
    }


    chooseEmail(updateProperties) {
        const newUser = _.cloneDeep(this.props.user);
        // newUser.email = updateProperties.email;
        newUser.email = updateProperties.item.email;
        this.props.onUserUpdate(newUser);
    }

    openAddUserPopup() {
        this.setState({
            isOpenAddUserPopup: true,
        });
    }

    closeAddUserPopup() {
        this.setState({
            isOpenAddUserPopup: false,
        });
    }

    render() {
        const errorUser = this.props.errorUser ? this.props.errorUser.message : '';
        const { email, emails, isOpenAddUserPopup } = this.state;
        const { client, handleClientChange, letter } = this.props;

        const isB2BRequest = letter.eh === 'api';
        const emailReceiver = letter.receiver && letter.receiver[0] && letter.receiver[0].address;

        const availableBrokers = [];

        if (letter.expectedBroker) {
            availableBrokers.push({
                value: letter.expectedBroker.email,
                name: letter.expectedBroker.email,
            });
        }
        if (emailReceiver) {
            if (!availableBrokers.some(b => b.value === emailReceiver)) {
                availableBrokers.push({
                    value: emailReceiver,
                    name: emailReceiver,
                });
            }
        }

        return (
            <div className={cx('sidebar-table', { disabled: isB2BRequest })}>
                <CreateUserPopup
                    isOpen={isOpenAddUserPopup}
                    user={this.props.user}
                    onUserUpdate={this.props.onUserUpdate}
                    closeAddUserPopup={this.closeAddUserPopup}
                />
                <div className='title'>
                    CONTACTS
                </div>

                {
                    isB2BRequest && (
                        <div style={{ marginBottom: '1em', fontStyle: 'italic' }}>NOTE: This value handled automatically by system</div>
                    )
                }

                <div className='row half'>
                    <div className='column-left'>
                        <RaisedButton
                            labelStyle={{ fontSize: '10px' }}
                            style={{ height: '25px' }}
                            buttonStyle={{ height: '25px', lineHeight: '25px' }}
                            label='Add new user'
                            onClick={this.openAddUserPopup}
                            primary
                        />
                    </div>
                </div>

                <div className='row'>
                    <div className='one-forth' style={{ justifyContent: 'start' }}>
                        User email:
                    </div>
                    <div className='one-forth' style={{ justifyContent: 'center' }}>
                        <AutoComplete
                            name='userEmail'
                            textFieldStyle={{ fontSize: '13px' }}
                            hintText='User email or id'
                            errorText={errorUser}
                            searchText={email}
                            dataSource={emails || []}
                            dataSourceConfig={{ text: 'email', value: 'item' }}
                            onUpdateInput={this.changeEmail}
                            onNewRequest={this.chooseEmail}
                            filter={AutoComplete.noFilter}
                            listStyle={{ overflow: 'auto', maxHeight: '300px' }}
                            popoverProps={{
                                canAutoPosition: true,
                            }}
                            fullWidth
                        />
                    </div>
                    <div className="one-forth">Broker:</div>
                    <div className='one-forth'>
                        <SelectField
                            title={client}
                            floatingLabelText="Broker"
                            style={{ fontSize: '13px', marginTop: '-25px' }}
                            value={client}
                            fullWidth
                            onChange={handleClientChange}
                            disabled={letter.mailCustomGroup}
                            autoWidth
                        >
                            <MenuItem value="" primaryText="" />
                            {
                                availableBrokers.map((b, i) => <MenuItem key={`availableBrokers_${i}`} value={b.value} primaryText={b.name} title={b.title || b.value} />)
                            }
                            <MenuItem value="d.zaharov@shipnext.com" primaryText="Test (d.zaharov)" />
                            <MenuItem value="broker@l3r.net" primaryText="l3r" />
                        </SelectField>
                    </div>
                </div>
            </div>
        );
    }
}

export default UserSelector;



// WEBPACK FOOTER //
// ./app/components/Base/UserSelector/UserSelector.jsx